import React from 'react'

const DashboardPage = () => {
  return (
    <div>DashboardPage</div>
  )
}

export default DashboardPage